import PanelNew from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import logo from './user.svg'
import getError from '@/containers/SubscriptionFormPage/getError'
import Disclaimer from '@/containers/SubscriptionFormPageNew/Components/Contact/Fields/Default/Disclaimer/Disclaimer'
import useContact from './useContact'
import { FormControl } from 'baseui/form-control'
import SecondName from './Fields/Default/SecondName'
import { IS_PROFESSIONAL } from '../../SubscriptionForm/Common/constants'
import ClientType from './Fields/Default/ClientType'
import Email from '@/containers/SubscriptionFormPageNew/Components/Contact/Fields/Default/Email/Email'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import NewsletterBonsPlans from '@/containers/SubscriptionFormPageNew/Components/Contact/Fields/Default/Newsletter/NewsletterBonsPlans'
import { formControlOverrides } from '@/shared/components/SDComponentsNewDesign/styled-components'
import Birthdate from '@/containers/SubscriptionFormPageNew/Components/Contact/Fields/Default/Birthdate/Birthdate'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'
import GenericInputField from './Fields/Default/GenericInputField'
import ProActivity from './Fields/Default/ProActivity'
import Subtitle from './Fields/Default/Subtitle'
import Referral from './Fields/Default/Referral'
import ClientTypeValidationWarning from '@/containers/SubscriptionFormPageNew/Components/MeterSaveButton/ClientTypeValidationWarning'
import Interactions from '@/containers/SubscriptionFormPageNew/Components/Interactions/Interactions'
import FiscalCodeCheckLink from './Fields/Default/FiscalCodeCheckLink'
import FiscalCode from '@/containers/SubscriptionFormPageNew/Components/Contact/Fields/Default/FiscalCode/FiscalCode'
import ClubSelectra from '@/containers/SubscriptionFormPageNew/Components/ClubSelectra/ClubSelectra'
import IdentityModal from '@/containers/SubscriptionFormPageNew/Components/Identity/IdentityModal'

const Contact = () => {
  const {
    t,
    customerUpdate,
    authorizeDataCollectionHandler,
    dataCollectionAuth,
    lastName,
    firstName,
    phone1,
    phone2,
    civility2,
    lastName2,
    firstName2,
    secondName,
    siret,
    socialReason,
    apeCode,
    activity,
    activitiesList,
    isEditable,
    errors,
    formIsLoaded,
    verifySiret,
    civility,
    finalOptionsCivility,
    removeErrors,
    siretIsLoading,
    siretIsValid,
    prefilledEmail,
    captionForceEmail,
    email,
    emailIsLoading,
    verifyEmail,
    isNewsletterRegistered,
    zohoIsInValid,
    clientTypeOptions,
    clientType,
    config,
    birthdate,
    bornCity,
    neverBounceResult,
    referral,
    referralFirstName,
    referralLastName,
    setErrors,
    hasClientTypeWarning,
    doorToDoorPartnerChecklistCompleted,
    isDoorToDoorPartner,
    LocalizedCompanyIdComponent,
  } = useContact()

  if (!formIsLoaded || zohoIsInValid) {
    return null
  }

  if (!dataCollectionAuth) {
    return (
      <>
        <Interactions hidden={!config.interactions} />
        <PanelNew
          logo={logo}
          alt={t('subscriptionForm:customer_module.module_title_new')}
          title={t('subscriptionForm:customer_module.module_title_new')}
          id='CustomerModule'
        >
          <Disclaimer
            disabled={isEditable === false || !doorToDoorPartnerChecklistCompleted}
            checked={dataCollectionAuth}
            setChecked={authorizeDataCollectionHandler}
          />
        </PanelNew>
      </>
    )
  }

  return (
    <>
      <Interactions hidden={!config.interactions} />
      <PanelNew
        logo={logo}
        alt={t('subscriptionForm:customer_module.module_title_new')}
        title={t('subscriptionForm:customer_module.module_title_new')}
        id='CustomerModule'
      >
        <Disclaimer
          disabled={isEditable === false || !doorToDoorPartnerChecklistCompleted}
          checked={dataCollectionAuth}
          setChecked={authorizeDataCollectionHandler}
        />
        <ClientType
          clientTypeOptions={clientTypeOptions}
          clientType={clientType}
          isEditable={isEditable}
          updateClientTypeHandler={value => customerUpdate({ data: { clientType: value }, name: 'preferences' })}
          mandatory={mandatoryTag}
          errorText={getError('contract_type', errors)}
          label={t('subscriptionForm:customer_module.client_type.label')}
        />
        <ClientTypeValidationWarning showWarning={hasClientTypeWarning} />

        <LocalizedCompanyIdComponent
          hidden={!config.siret || clientType !== IS_PROFESSIONAL}
          disabled={isEditable === false}
          currentValue={siret}
          onChangeHandler={siret => customerUpdate({ data: { siret }, name: 'professional' })}
          removeErrors={removeErrors}
          setErrors={setErrors}
          validationHandler={verifySiret}
          isLoading={siretIsLoading}
          status={siretIsValid}
          mandatory={mandatoryTag}
          error={getError('pro_siret', errors)}
        />
        <GenericInputField
          hidden={clientType !== IS_PROFESSIONAL}
          error={getError('pro_social_reason', errors)}
          value={socialReason}
          label={t('subscriptionForm:customer_module.proSocialReason.label')}
          isEditable={isEditable}
          onBlur={socialReason => customerUpdate({ data: { socialReason }, name: 'professional' })}
        />
        <GenericInputField
          hidden={!config.apeCode || clientType !== IS_PROFESSIONAL}
          isEditable={isEditable}
          value={apeCode}
          label={t('subscriptionForm:customer_module.proCodeApe.label')}
          error={getError('pro_ape_code', errors)}
          onBlur={apeCode => customerUpdate({ data: { apeCode }, name: 'professional' })}
        />
        <ProActivity
          hidden={!config.activity || clientType !== IS_PROFESSIONAL}
          error={getError('pro_activity', errors)}
          isEditable={isEditable}
          options={activitiesList}
          label={t('subscriptionForm:customer_module.proActivity.label')}
          onChangeHandler={params => customerUpdate({ data: { activity: params.option?.id }, name: 'professional' })}
          placeholder={t('subscriptionForm:customer_module.proActivity.placeholder')}
          value={activity}
        />
        <Subtitle hidden={clientType !== IS_PROFESSIONAL} text={t('subscriptionForm:customer_module.proContact')} />

        <FormControl
          label={() => (
            <div
              dangerouslySetInnerHTML={{ __html: mandatoryTag + t('subscriptionForm:customer_module.civility.label') }}
            />
          )}
          error={getError('civility', errors)}
          overrides={formControlOverrides}
        >
          <SDButtonGroup
            disabled={isEditable === false}
            onClickHandler={value => customerUpdate({ data: { civility: value }, name: 'personal' })}
            options={finalOptionsCivility ?? []}
            selectedValue={civility}
            error={getError('civility', errors) !== ''}
          />
        </FormControl>

        <GenericInputField
          id='input-customer-lastname'
          error={getError('lastname', errors)}
          value={lastName ?? ''}
          label={mandatoryTag + t('subscriptionForm:customer_module.lastname.label')}
          isEditable={isEditable}
          onBlur={lastName => customerUpdate({ data: { lastName }, name: 'personal' })}
          // onBlur={e => customerUpdate({ pdlEligibilityName: e.target.value })}
        />
        <GenericInputField
          id='input-customer-firstname'
          error={getError('firstname', errors)}
          value={firstName ?? ''}
          label={mandatoryTag + t('subscriptionForm:customer_module.firstname.label')}
          isEditable={isEditable}
          onBlur={firstName => customerUpdate({ data: { firstName }, name: 'personal' })}
        />

        <Birthdate
          key={birthdate}
          disabled={isEditable === false}
          currentValue={birthdate}
          error={getError('birthday', errors)}
          mandatory={config.birthdateMandatory ? mandatoryTag : ''}
          onChangeHandler={birthdate => customerUpdate({ data: { birthdate }, name: 'personal' })}
          removeErrors={removeErrors}
          setErrors={setErrors}
        />

        <GenericInputField
          id='input-customer-born-city'
          error={getError('bornCity', errors)}
          value={bornCity}
          label={mandatoryTag + t('subscriptionForm:customer_module.bornCity.label')}
          isEditable={isEditable}
          onBlur={bornCity => customerUpdate({ data: { bornCity }, name: 'personal' })}
          hidden={!config.bornCity}
        />

        <GenericInputField
          id='input-customer-phone1'
          error={getError('phone1', errors)}
          value={phone1}
          label={mandatoryTag + t('subscriptionForm:customer_module.phone1.label')}
          isEditable={isEditable}
          onBlur={phone1 => customerUpdate({ data: { phone1 }, name: 'personal' })}
        />
        <GenericInputField
          error={getError('phone2', errors)}
          value={phone2}
          label={t('subscriptionForm:customer_module.phone2.label')}
          isEditable={isEditable}
          onBlur={phone2 => customerUpdate({ data: { phone2 }, name: 'personal' })}
        />

        <Email
          caption={prefilledEmail.status ? prefilledEmail.message : ''}
          disabled={isEditable === false}
          captionForceEmail={captionForceEmail}
          currentValue={email}
          neverBounceResult={neverBounceResult}
          error={getError('email', errors)}
          isLoading={emailIsLoading}
          mandatory=''
          updateNeverBounce={value => customerUpdate({ data: { neverBounceResult: value }, name: 'preferences' })}
          removeErrors={removeErrors}
          verifyEmail={verifyEmail}
        />

        <ClubSelectra hidden={!config.clubSelectra} version='v2' module='contact' />

        <NewsletterBonsPlans
          hidden={isDoorToDoorPartner || !config.newsletter}
          disabled={isEditable === false}
          emailHasError={getError('email', errors)}
          isNewsletterRegistered={isNewsletterRegistered}
        />

        <SecondName
          currentValue={secondName}
          onClickHandler={secondName => customerUpdate({ data: { secondName }, name: 'personal' })}
          disabled={isEditable === false}
          hidden={!config.secondName}
        >
          <FormControl
            label={() => (
              <div
                dangerouslySetInnerHTML={{
                  __html: mandatoryTag + t('subscriptionForm:customer_module.civility2.label'),
                }}
              />
            )}
            error={getError('civility2', errors)}
            overrides={formControlOverrides}
          >
            <SDButtonGroup
              disabled={isEditable === false}
              onClickHandler={civility2 => customerUpdate({ data: { civility2 }, name: 'personal' })}
              options={finalOptionsCivility ?? []}
              selectedValue={civility2}
              newTranslations={true}
              error={getError('civility2', errors) !== ''}
              translationsPath='subscriptionForm:customer_module.civility.'
            />
          </FormControl>
          <GenericInputField
            error={getError('lastname2', errors)}
            value={lastName2}
            label={mandatoryTag + t('subscriptionForm:customer_module.lastname2.label')}
            isEditable={isEditable}
            onBlur={lastName2 => customerUpdate({ data: { lastName2 }, name: 'personal' })}
          />
          <GenericInputField
            error={getError('firstname2', errors)}
            value={firstName2}
            label={mandatoryTag + t('subscriptionForm:customer_module.firstname2.label')}
            isEditable={isEditable}
            onBlur={firstName2 => customerUpdate({ data: { firstName2 }, name: 'personal' })}
          />
        </SecondName>
        <Referral
          currentValue={referral}
          onClickHandler={referral => customerUpdate({ data: { referral }, name: 'additional' })}
          disabled={isEditable === false}
          hidden={!config.referral}
        >
          <GenericInputField
            error={getError('referral_firstname', errors)}
            value={referralFirstName}
            label={mandatoryTag + t('subscriptionForm:customer_module.referral.firstname')}
            isEditable={isEditable}
            onBlur={referralFirstName => customerUpdate({ data: { referralFirstName }, name: 'additional' })}
          />
          <GenericInputField
            error={getError('referral_lastname', errors)}
            value={referralLastName}
            label={mandatoryTag + t('subscriptionForm:customer_module.referral.lastname')}
            isEditable={isEditable}
            onBlur={referralLastName => customerUpdate({ data: { referralLastName }, name: 'additional' })}
          />
        </Referral>
        <FiscalCode />
        <FiscalCodeCheckLink hidden={!config.taxIdCode} />
        <IdentityModal />
      </PanelNew>
    </>
  )
}

export default Contact
